/**
 * Reset search experience to initial state
 *
 */
export default function reset() {
  var _console; // eslint-disable-next-line no-console


  if (this.debug) (_console = console).log.apply(_console, ["Search UI: Action", "reset"].concat(Array.prototype.slice.call(arguments)));

  this._setState(this.startingState);

  if (this.trackUrlState) {
    this.URLManager.pushStateToURL(this.state);
  }
}